import { twMerge } from "tailwind-merge";
import { ContentFrameBase } from "@core/ui";
import { ElementType, ReactNode } from "react";

export type Props = {
  /** Element type to render */
  as?: ElementType;
  /** Content to render */
  children: ReactNode;
  /** Additional CSS classes for outer container */
  className?: string;
  /** Additional CSS classes for inner container */
  innerClassName?: string;
  /** ID attribute */
  id?: string;
  /** Test ID for testing */
  "data-testid"?: string;
};

/**
 * Styled centered content frame wrapping ContentFrameBase.
 * Provides max-width constraints and centered layout.
 */
export function InnerContentFrame({
  as,
  children,
  className,
  innerClassName,
  id,
  "data-testid": dataTestId = "inner-content-frame",
}: Props) {
  return (
    <ContentFrameBase
      as={as}
      className={twMerge("flex items-center justify-center", className)}
      innerClassName={twMerge(
        "flex flex-col items-center justify-center w-full py-4 px-8 max-w-xl md:justify-start md:items-start md:p-8",
        innerClassName
      )}
      id={id}
      data-testid={dataTestId}
    >
      {children}
    </ContentFrameBase>
  );
}

export default InnerContentFrame;

